export const CardFlavours = {
  /** When you are editing your own card */
  PERSONAL: 'personal',
  /** When you are the admin editing a card for a team member */
  TEAM: 'team',
  /** Editing a template */
  TEMPLATE: 'template',
  CLAIM: 'claim',
  INVITE_TOKEN_CLAIM: 'invite-token-claim',
  ADD_DETAILS: 'add-details',
} as const;

export type CardFlavour = (typeof CardFlavours)[keyof typeof CardFlavours];

export type CardMode = 'clickable' | 'read-only' | 'edit' | undefined;
